import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";

import { NotificationManager } from "react-notifications";

import { Accordion } from "react-bootstrap";
import UnionIcon from "../../../assets/images/icons/Union_5.svg";
import { useTranslation } from "react-i18next";
import PendantBuilderService from "../../../services/apps-pendantBuilder.service";
import { Select, Spin, Switch, Tooltip } from "antd";
import appsDiamondlinksService from "../../../services/apps-diamondlinks.service";

const { Option } = Select;

export const PendantBuilderOptions = (props) => {
  const { t } = useTranslation();
  /*React Binding Starts*/
  const [ViewOptionData, setViewOptionData] = useState({
    pendantBuilderUrl: "",
    InternalUseLink: false,
    ShowAdvancedSearch: false,
    ScheduleViewing: true,
    ShowAddress: true,
    ShowVendorSKU: true,
    ShowCallForPrice: false,
    GSTTax: false,
    GSTTaxValue: "",
    PinterestShare: false,
    TwitterShare: false,
    FacebookShare: false,
    FacebookLike: false,
    ShoppingCartURL: "",
    ShowAddToCartBtn: false,
    ShowViewCart: false,
    showInstagramShare: false,
    isShowEcommerce: true,
    showDiamondPrices: true,
    showLabGrownDiamondPrices: true,
  });

  const [diamondLinkOptionData, setDiamondLinkOptionData] = useState({
    showDiamondPrices: true,
    showLabGrownDiamondPrices: true,
  });

  const handleOnChange = (e, isSelect, name) => {
    if (isSelect == "GSTTaxValue") {
      const rx_live = /^[+-]?\d*(?:[.,]\d*)?$/;
      if (!rx_live.test(e.target.value)) {
        return false;
      }
    }
    setDisableBtn(false);

    if (isSelect === "select") {
      setViewOptionData({
        ...ViewOptionData,
        [name]: e,
      });
    } else {
      setViewOptionData({
        ...ViewOptionData,
        [e.target.name]: e.target.value,
      });
    }
  };

  /*React Binding Ends*/

  /*API Binding Starts*/
  const loginDetials = useSelector((state) => state.loginReducer);
  const [dealerId, setDealerId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [disableBtn, setDisableBtn] = useState(true);
  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleGetsPendantBuilderOptiondetails(
            loginDetials.loginDetials.responseData.dealerId
          );
          handleGetOptionsDiamondDetails(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
  }, []);
  const handleGetsPendantBuilderOptiondetails = (id) => {
    let inputData = {
      dealerID: id,
    };
    setLoading(true);
    try {
      PendantBuilderService.GetsPendantBuilderOptiondetails(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData[0];
          if (message === "Success") {
            if (responseData) {
              if (response.data.responseData.length > 0) {
                setViewOptionData((prevState) => ({
                  ...prevState,
                  pendantBuilderUrl: responseData.pendantBuilderURL,
                  InternalUseLink: responseData.internalLinkPB,
                  ShowAdvancedSearch:
                    responseData.isDefaultAdvanceSearchPendant,
                  ScheduleViewing: responseData.showScheduleView,
                  ShowAddress: responseData.showAddresses,
                  ShowVendorSKU: responseData.showVendorSKU,
                  ShowCallForPrice: responseData.callForPricependant,
                  GSTTax: responseData.showGstPrice,
                  GSTTaxValue: responseData.taxRate,
                  PinterestShare: responseData.showPinterestShare,
                  TwitterShare: responseData.showTwitterShare,
                  FacebookShare: responseData.showFacebookShare,
                  FacebookLike: responseData.showFacebookLike,
                  showInstagramShare: responseData.showInstagramShare,
                  ShowAddToCartBtn: responseData.showAddToCartButtonPendant,
                  ShowViewCart: responseData.showViewCartButtonPendant,
                  ShoppingCartURL: responseData.diamondpendentshoppingurl,
                  isShowEcommerce: responseData.isShowEcommerce,
                }));
              }
            }
            setLoading(false);
          } else {
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const handleSubmit = () => {
    try {
      setSubmitLoading(true);
      setLoading(true);
      let inputData = {
        dealerID: dealerId,
        type: "PendantBuilder",
        diamondpendentshoppingurl: ViewOptionData.ShoppingCartURL,
        callForPricependant: ViewOptionData.ShowCallForPrice,
        isDefaultAdvanceSearchPendant: ViewOptionData.ShowAdvancedSearch,
        showScheduleView: ViewOptionData.ScheduleViewing,
        showAddToCartButtonPendant: ViewOptionData.ShowAddToCartBtn,
        showViewCartButtonPendant: ViewOptionData.ShowViewCart,
        showAddresses: ViewOptionData.ShowAddress,
        showVendorSKU: ViewOptionData.ShowVendorSKU,
        pendantBuilderURL: ViewOptionData.pendantBuilderUrl,
        internalLinkPB: ViewOptionData.InternalUseLink,
        showGstPrice: ViewOptionData.GSTTax,
        taxRate: ViewOptionData.GSTTaxValue ? ViewOptionData.GSTTaxValue : "0",
        showPinterestShare: ViewOptionData.PinterestShare,
        showTwitterShare: ViewOptionData.TwitterShare,
        showFacebookShare: ViewOptionData.FacebookShare,
        showFacebookLike: ViewOptionData.FacebookLike,
        showGooglePlus: true,
        showInstagramShare: ViewOptionData.showInstagramShare,
      };
      setLoading(true);
      PendantBuilderService.UpdatePendantBuilderOptiondetails(inputData)
        .then((response) => {
          let message = response.data.message;
          setLoading(false);
          setSubmitLoading(false);
          if (message === "Success") {
            handleDiamondSubmit();
          } else {
            NotificationManager.error(t("Data not Updated."));
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          setSubmitLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
      setSubmitLoading(false);
    }
    setDisableBtn(true);
  };

  const handleDiamondSubmit = () => {
    try {
      setSubmitLoading(true);
      let inputData = {
        dealerID: dealerId,
        type: "DiamondLink",
        diamondLinkURL: diamondLinkOptionData.diamondLinkURL,
        internalLinkDL: diamondLinkOptionData.internalUseLink,
        allowNewDiamondDealers: diamondLinkOptionData.acceptNewDiamondDealers,
        searchSortName: diamondLinkOptionData.sortSearchResultsInitiallyBy,
        searchSortOrder: diamondLinkOptionData.orderSearchResultsInitiallyBy,
        showInhouseDiamonds: diamondLinkOptionData.showInHouseDiamondsSKU,
        showInhouseFirst: diamondLinkOptionData.showInHouseDiamondsFirst,
        displayVendorSku: diamondLinkOptionData.displayVendorSKU,
        showDiamondFilter: diamondLinkOptionData.showDiamondFilter,
        showGIAreportchecklink: diamondLinkOptionData.showGIAReportCheckLink,
        showAdvanceOptionInDiamondSearch:
          diamondLinkOptionData.showAdvanceOptionsAsDefault,
        showCertificateDiamondSearch:
          diamondLinkOptionData.showCertificateInDiamondSearch,
        showEGLVariants: diamondLinkOptionData.showEGLCertificateVariants,
        requestCer: diamondLinkOptionData.showRequestCertificate,
        disableCertificate: diamondLinkOptionData.disableCertificateLinks,
        showcoloritemsoutofrange:
          diamondLinkOptionData.showColorItemsOutOfRange,
        showclarityitemsoutofrange:
          diamondLinkOptionData.showClarityItemsOutOfRange,
        acceptTotalPrice: diamondLinkOptionData.acceptTotalPriceForDiamond,
        isScheduleViewing: diamondLinkOptionData.scheduleViewing,
        dropaHint: diamondLinkOptionData.dropAHint,
        emailAFriend: diamondLinkOptionData.emailAFriend,
        showOriginDiamondSearch:
          diamondLinkOptionData.showOriginOnDiamondSearch,
        showCommentsOnDetailPage:
          diamondLinkOptionData.showVendorCommentsOnDetailsPage,
        showContact: diamondLinkOptionData.showContactNumber,
        showAddresses: diamondLinkOptionData.showAddresses,
        searchPageDetailLinkURL:
          diamondLinkOptionData.alternateDiamondDetailsLinkURL,
        useCustomDetailURL: diamondLinkOptionData.customDetailURL,
        showDiamondPricesOnPage: diamondLinkOptionData.showDiamondPrices,
        showPricesOnSearchPageFancy:
          diamondLinkOptionData.showFancyColorDiamondPrices,
        showPricesOnSearchPageLab:
          diamondLinkOptionData.showLabGrownDiamondPrices,
        markupOwnInventory: diamondLinkOptionData.markupYourOwnInventory,
        showPricePerCarat: diamondLinkOptionData.showPricePerCarat,
        showGstPrice: diamondLinkOptionData.applyGstTax,
        taxRate: diamondLinkOptionData.gstTaxValue,
        showPinterestShare: diamondLinkOptionData.showPinterestShare,
        showTwitterShare: diamondLinkOptionData.showTwitterShare,
        showFacebookShare: diamondLinkOptionData.showFacebookShare,
        showFacebookLike: diamondLinkOptionData.showFacebookLike,
        showInstagramShare: diamondLinkOptionData.showInstagramShare,
        ShowGooglePlus: diamondLinkOptionData.ShowGooglePlus,
        showAddToCartButton: diamondLinkOptionData.ctaButton
          ? diamondLinkOptionData.myOptionRadio == "addToCartBtn"
            ? 1
            : diamondLinkOptionData.myOptionRadio == "scheduleAViewing"
            ? 2
            : diamondLinkOptionData.myOptionRadio == "requestMoreInfo"
            ? 0
            : 3
          : 3,
        alternateShoppingCartURL:
          diamondLinkOptionData.alternateShoppingCartURL,
        showViewCartButton: diamondLinkOptionData.showViewCartButton,
        showAddToCartButtonOnSearchPage:
          diamondLinkOptionData.showAddToCartButton,
      };
      setLoading(true);
      appsDiamondlinksService
        .UpdateDiamondLinkOptionDetailsUpload(inputData)
        .then((response) => {
          let message = response.data.message;

          setLoading(false);
          setSubmitLoading(false);
          if (message === "Success") {
            NotificationManager.success(t("Data Updated Successfully."));
            handleGetOptionsDiamondDetails(dealerId);
            handleGetsPendantBuilderOptiondetails(dealerId);
          } else {
            NotificationManager.error(t("Data not Updated."));
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          setSubmitLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
      setSubmitLoading(false);
    }
    setDisableBtn(true);
  };

  const handleGetOptionsDiamondDetails = (id) => {
    let inputData = {
      dealerID: id,
      type: "DiamondLink",
    };
    setLoading(true);
    try {
      appsDiamondlinksService
        .GetOptionsDetails(inputData)
        .then((response) => {
          setLoading(false);

          let message = response.data.message;
          let responseData = response.data.responseData[0];
          if (message === "Success") {
            if (responseData) {
              setDiamondLinkOptionData((prevState) => ({
                ...prevState,
                diamondLinkURL: responseData.diamondLinkURL,
                internalUseLink: responseData.internalLinkDL,
                acceptNewDiamondDealers: responseData.allowNewDiamondDealers,
                sortSearchResultsInitiallyBy: responseData.searchSortName,
                orderSearchResultsInitiallyBy: responseData.searchSortOrder,
                showInHouseDiamondsSKU: responseData.showInhouseDiamonds,
                displayVendorSKU: responseData.displayVendorSku,
                showDiamondFilter: responseData.showDiamondFilter,
                showInHouseDiamondsFirst: responseData.showInhouseFirst,
                showGIAReportCheckLink: responseData.showGIAreportchecklink,
                showAdvanceOptionsAsDefault:
                  responseData.showAdvanceDiamondSearch,
                showCertificateInDiamondSearch:
                  responseData.showCertificateDiamondSearch,
                showEGLCertificateVariants: responseData.showEGLVariants,
                showRequestCertificate: responseData.requestCer,
                disableCertificateLinks: responseData.disableCertificate,
                showColorItemsOutOfRange: responseData.showcoloritemsoutofrange,
                showClarityItemsOutOfRange:
                  responseData.showclarityitemsoutofrange,
                acceptTotalPriceForDiamond: responseData.acceptTotalPrice,
                scheduleViewing: responseData.isScheduleViewing,
                dropAHint: responseData.dropaHint,
                emailAFriend: responseData.emailAFriend,
                showOriginOnDiamondSearch: responseData.showOriginDiamondSearch,
                showVendorCommentsOnDetailsPage:
                  responseData.showCommentsOnDetailPage,
                showContactNumber: responseData.showContact,
                showAddresses: responseData.showAddresses,
                alternateDiamondDetailsLinkURL:
                  responseData.searchPageDetailLinkURL,
                customDetailURL: responseData.useCustomDetailURL,
                showDiamondPrices: responseData.showPricesOnSearchPage,
                showFancyColorDiamondPrices:
                  responseData.showPricesOnSearchPageFancy,
                showLabGrownDiamondPrices:
                  responseData.showPricesOnSearchPageLab,
                markupYourOwnInventory: responseData.markupOwnInventory,
                showPricePerCarat: responseData.showPricePerCarat,
                applyGstTax: responseData.showGstPrice,
                gstTaxValue: responseData.taxRate,
                showPinterestShare: responseData.showPinterestShare,
                showTwitterShare: responseData.showTwitterShare,
                showFacebookShare: responseData.showFacebookShare,
                showFacebookLike: responseData.showFacebookLike,
                showInstagramShare: responseData.showInstagramShare,
                ShowGooglePlus: responseData.showGooglePlus,
                ctaButton:
                  responseData.showAddToCartButton == 1
                    ? true
                    : responseData.showAddToCartButton == 2
                    ? true
                    : responseData.showAddToCartButton == 0
                    ? true
                    : responseData.showAddToCartButton == 3
                    ? false
                    : null,
                alternateShoppingCartURL: responseData.alternateShoppingCartURL,
                myOptionRadio:
                  responseData.showAddToCartButton == 1
                    ? "addToCartBtn"
                    : responseData.showAddToCartButton == 2
                    ? "scheduleAViewing"
                    : responseData.showAddToCartButton == 0
                    ? "requestMoreInfo"
                    : null,
                showViewCartButton: responseData.showViewCartButton,
                showAddToCartButton:
                  responseData.showAddToCartButtonOnSearchPage,
                isShowEcommerce: responseData.isShowEcommerce,
              }));
            }
          } else {
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleOnDiamondLinkChange = (e, isSelect, name) => {
    setDisableBtn(false);
    if (isSelect === "select") {
      setDiamondLinkOptionData({
        ...diamondLinkOptionData,
        [name]: e,
      });
    } else {
      setDiamondLinkOptionData({
        ...diamondLinkOptionData,
        [e.target.name]: e.target.value,
      });
    }
  };

  /*API Binding Ends*/

  return (
    <div className="form__fields markup__section">
      <div className="row ">
        <div className="col-md-12">
          <div className="heading__block">
            <h4 className="workarea__heading mt-0 mb-1"> {t("Options")} </h4>
          </div>
        </div>
      </div>

      <Spin spinning={loading}>
        <div className="row ">
          <div className="col-md-12">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div>
                    <label> {t("Setup")} </label>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Pendant Builder URL")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Enter the URL of this tool on your site to enable social sharing and dynamic sizing."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <input
                          type="text"
                          name="pendantBuilderUrl"
                          className="mr-2"
                          value={
                            ViewOptionData.pendantBuilderUrl
                              ? ViewOptionData.pendantBuilderUrl
                              : null
                          }
                          onChange={(e) =>
                            handleOnChange(e, "pendantBuilderUrl")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Internal Use Link")} ?
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the “For Internal Use Only” link at the bottom of the Diamond Details page, which will allow you to look up the vendor’s stock # and contact info for the viewed diamond."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="InternalUseLink"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.InternalUseLink}
                          onChange={(e) =>
                            handleOnChange(e, "select", "InternalUseLink")
                          }
                        />
                      </div>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div>
                    <label htmlFor="h1"> {t("Display")} </label>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Advanced Search As Default")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the Advanced optional filtering by default (Polish, Symmetry, Flourescence, Certs… etc."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="ShowAdvancedSearch"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.ShowAdvancedSearch}
                          onChange={(e) =>
                            handleOnChange(e, "select", "ShowAdvancedSearch")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Schedule Viewing")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the link which allows the customer the ability to schedule an appointment."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="ScheduleViewing"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.ScheduleViewing}
                          onChange={(e) =>
                            handleOnChange(e, "select", "ScheduleViewing")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Addresses")}
                          <Tooltip
                            placement="right"
                            title={t("Allow address to show on detailpage.")}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="ShowAddress"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.ShowAddress}
                          onChange={(e) =>
                            handleOnChange(e, "select", "ShowAddress")
                          }
                        />
                      </div>
                    </div>


                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Display Vendor SKU")}
                          <Tooltip
                            placement="right"
                            title={t("Display Vendor SKU")}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="ShowVendorSKU"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.ShowVendorSKU}
                          onChange={(e) =>
                            handleOnChange(e, "select", "ShowVendorSKU")
                          }
                        />
                      </div>
                    </div>

                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  <div>
                    <label> {t("Price")} </label>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Setting Price")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display “Call for Price” instead of the retail price or not."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="ShowCallForPrice"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.ShowCallForPrice}
                          onChange={(e) =>
                            handleOnChange(e, "select", "ShowCallForPrice")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Mined Diamond Price")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "You may choose not to show mined diamond prices in search results if desired. Price range field in search form is not displayed when prices are not displayed."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showDiamondPrices"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          defaultChecked
                          checked={diamondLinkOptionData.showDiamondPrices}
                          onChange={(e) =>
                            handleOnDiamondLinkChange(
                              e,
                              "select",
                              "showDiamondPrices"
                            )
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Lab Grown Diamond Price")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "You may choose not to show lab grown diamond prices in search results if desired. Price range field in search form is not displayed when prices are not displayed."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showLabGrownDiamondPrices"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          defaultChecked
                          checked={
                            diamondLinkOptionData.showLabGrownDiamondPrices
                          }
                          onChange={(e) =>
                            handleOnDiamondLinkChange(
                              e,
                              "select",
                              "showLabGrownDiamondPrices"
                            )
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Apply GST Tax")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Toggle the ability to apply international tax."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="GSTTax"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.GSTTax}
                          onChange={(e) =>
                            handleOnChange(e, "select", "GSTTax")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("GST Tax Value")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Set the value when applying the GST Tax option."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <input
                          type="text"
                          maxLength="2"
                          name="GSTTaxValue"
                          className="mr-2"
                          value={
                            ViewOptionData.GSTTaxValue
                              ? ViewOptionData.GSTTaxValue
                              : ViewOptionData.GSTTaxValue == "0"
                              ? "0"
                              : ""
                          }
                          onChange={(e) => handleOnChange(e, "GSTTaxValue")}
                        />
                      </div>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  <div>
                    <label> {t("Social")} </label>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="row">


                    <div className="col-md-6">
                      <div className="input__block">
                        <label>
                          {t("Show Instagram Share")}
                          <Tooltip
                            placement="right"
                            title={
                              "Choose whether to display the Instagram “Share” button or not."
                            }
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showInstagramShare"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.showInstagramShare}
                          onChange={(e) =>
                            handleOnChange(e, "select", "showInstagramShare")
                          }
                        />
                      </div>
                    </div>

                    {/* <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Pinterest Share")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the Pinterest “Pin it” button or not."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="PinterestShare"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.PinterestShare}
                          onChange={(e) =>
                            handleOnChange(e, "select", "PinterestShare")
                          }
                        />
                      </div>
                    </div> */}

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Twitter Share")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the Twitter “Tweet” button or not."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="TwitterShare"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.TwitterShare}
                          onChange={(e) =>
                            handleOnChange(e, "select", "TwitterShare")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Facebook Share")}
                          <Tooltip
                            placement="right"
                            title={t(
                              `Choose whether to display the Facebook “Share” button or not.`
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="FacebookShare"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.FacebookShare}
                          onChange={(e) =>
                            handleOnChange(e, "select", "FacebookShare")
                          }
                        />
                      </div>
                    </div>

                    {/* <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Facebook Like")}
                          <Tooltip
                            placement="right"
                            title={t(
                              `Choose whether to display the Facebook “Like” button or not.`
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="FacebookLike"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.FacebookLike}
                          onChange={(e) =>
                            handleOnChange(e, "select", "FacebookLike")
                          }
                        />
                      </div>
                    </div> */}

                  </div>
                </Accordion.Body>
              </Accordion.Item>
              {ViewOptionData.isShowEcommerce &&
              ViewOptionData.isShowEcommerce == true ? (
                <Accordion.Item eventKey="6">
                  <Accordion.Header>
                    <div>
                      <label> {t("E-Commerce")} </label>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="input__block">
                          <label>
                            {t("Shopping Cart Url")}
                            <Tooltip
                              placement="right"
                              title={t(
                                "Change this value to alter the actual hyperlink to the shopping cart. This could be changed to link to your own shopping cart page. Additional diamond detail parameters are passed in the URL when this value is present. Leave blank for default value."
                              )}
                            >
                              <img src={UnionIcon} alt="" />
                            </Tooltip>
                          </label>
                          <input
                            type="text"
                            name="ShoppingCartURL"
                            className="mr-2"
                            value={
                              ViewOptionData.ShoppingCartURL
                                ? ViewOptionData.ShoppingCartURL
                                : null
                            }
                            onChange={(e) =>
                              handleOnChange(e, "ShoppingCartURL")
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="input__block">
                          <label>
                            {t("Show Add To Cart Button")}
                            <Tooltip
                              placement="right"
                              title={t(
                                "Choose whether to display the “Add to Cart” button or not."
                              )}
                            >
                              <img src={UnionIcon} alt="" />
                            </Tooltip>
                          </label>
                          <Switch
                            name="ShowAddToCartBtn"
                            checkedChildren={t("Yes")}
                            unCheckedChildren={t("No")}
                            checked={ViewOptionData.ShowAddToCartBtn}
                            onChange={(e) =>
                              handleOnChange(e, "select", "ShowAddToCartBtn")
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="input__block">
                          <label>
                            {t("Show")} {t("View Cart")} {t("Button")}
                            <Tooltip
                              placement="right"
                              title={t(
                                "Choose whether to display the “View Cart” button or not."
                              )}
                            >
                              <img src={UnionIcon} alt="" />
                            </Tooltip>
                          </label>
                          <Switch
                            name="ShowViewCart"
                            checkedChildren={t("Yes")}
                            unCheckedChildren={t("No")}
                            checked={ViewOptionData.ShowViewCart}
                            onChange={(e) =>
                              handleOnChange(e, "select", "ShowViewCart")
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ) : null}
            </Accordion>
            <div className="col-lg-12 mt-4">
              <button
                className={disableBtn ? "disabled-btn" : "primary-btn"}
                disabled={disableBtn}
                loading={submitLoading}
                onClick={handleSubmit}
              >
                {" "}
                {t("Update Settings")}{" "}
              </button>
            </div>
          </div>
        </div>
      </Spin>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PendantBuilderOptions);
